export function getPercent(value, quantity) {
  if (!quantity) return null;
  if (!value) return 0;

  return (value / quantity) * 100;
}

export function getPercentRounded(value, quantity) {
  return Math.round(getPercent(value, quantity));
}

export function getPercentFormatted(value, quantity) {
  return formatNumber(getPercent(value, quantity));
}

export function formatNumber(value) {
  return Intl.NumberFormat().format(value);
}

export function dataIsEmpty(value) {
  if (!value) return true;

  return false;
}
